import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    examTitleStyle: {
      color: theme.palette.primary.main,
      display: 'inline-block',
      border: '1px solid #fff',
      padding: `${theme.spacing(0.2)}px ${theme.spacing(1)}px`,
      borderRadius: theme.shape.borderRadius,
      background: '#fff',
    },
    appheaderStyle: {
      flexGrow: 1,
      display: 'flex',
    },
    headerStyle: {
      boxShadow: `0 1px 1px 0 ${theme.palette.grey[600]}`,
      backgroundColor: theme.palette.primary.main,
      height: 76,
    },
    logoStyle: {
      width: '35px',
      height: '35px',
    },
    toolbarStyle: {
      height: 'inherit',
    },
    titleStyle: {
      flexGrow: 1,
      fontSize: 18,
      fontWeight: 'bold',
      color: '#fff',
      paddingTop: 5,
    },
    btnHeaderStyle: {
      marginLeft: 32,
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.71,
      letterSpacing: 'normal',
    },
  }),
);
